module.exports = __webpack_public_path__ + "img/customer-service.828bf956.png";